module.exports = __webpack_public_path__ + "static/media/29EUNOG20.67c0a9ed.jpg";